import { render } from "./rightHang.vue?vue&type=template&id=61adbed4&scoped=true"
import script from "./rightHang.vue?vue&type=script&lang=js"
export * from "./rightHang.vue?vue&type=script&lang=js"

import "./rightHang.vue?vue&type=style&index=0&id=61adbed4&scoped=true&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61adbed4"]])

export default __exports__